var React = require('react');

function RightArrowInline (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"34.544 68.912 68 35.456 34.544 2 31.868 4.676 60.831 33.64 3 33.64 3 37.272 60.831 37.272 31.868 66.235"}));
}

RightArrowInline.defaultProps = {"width":"70","height":"70","viewBox":"0 0 70 70"};

module.exports = RightArrowInline;

RightArrowInline.default = RightArrowInline;
